const AUTO_RECONNECT_INTERVAL = 1000;

export default class WsClient {
    constructor(host) {
        this.host = host;
        this.ws = null;
        this._init();
        this._onMessage = null;
        this._lifecycleListener = null;
        this.isForceClose = false;
        this._isConnected = false;
        this._reconnect = true;
    }

    _init() {
        console.log(document.visibilityState)
        if (document.visibilityState === 'hidden') {
            this.reconnect();
            return;
        }
        //TODO debug log
        console.log('init web socket with host', this.host);
        this.ws = new WebSocket(this.host);
        this.ws.binaryType = "arraybuffer";
        this.ws.onopen = (event) => this.onopen(event);
        this.ws.onclose = (event) => this.onclose(event);
        this.ws.onmessage = (event) => this.onmessage(event);
        this.ws.onerror = (event) => this.onerror(event);
    }

    destroy() {
        this.isForceClose = true;
        this._reconnect = false;

        if (this.ws) this.ws.close();
    }

    onmessage(event) {
        //TODO debug log
        //console.log(event);
        if (this._onMessage) this._onMessage(event.data);
    }

    onopen(event) {
        //TODO debug log
        console.log(event);

        this._isConnected = true;

        if (this._lifecycleListener) {
            try {
                this._lifecycleListener.onopen(event);
            } catch (e) {}
        }
    }

    onerror(event) {
        //TODO debug log
        console.log(event);

        if (this._lifecycleListener) {
            try {
                this._lifecycleListener.onerror(event);
            } catch (e) {}
        }
    }

    onclose(event) {
        //TODO debug log
        console.log(event);

        this._isConnected = false;

        if (this._lifecycleListener) {
            try {
                this._lifecycleListener.onclose(event);
            } catch (e) {}
        }

        if (this.isForceClose) return;

        this.reconnect();
    }

    reconnect() {
        if (!this._reconnect) {
            return;
        }

        //TODO debug log
        console.log('reconnect');
        setTimeout(this._init.bind(this), AUTO_RECONNECT_INTERVAL);
    }

    forceClose() {
        if (this.ws) this.ws.close();
    }

    set onMessageListener(listener) {
        this._onMessage = listener;
    }

    set lifecycleListener(listener) {
        this._lifecycleListener = listener;
    }

    get isConnected() {
        return this._isConnected;
    }
    sendMessage(message) {
        if (!this.isConnected) {
            return false;
        }

        try {
            this.ws.send(message);
            return true;
        } catch (e) {
            //TODO debug log
            console.log(e);
            return false;
        }
    }

    setReconnect(reconnect) {
        this._reconnect = reconnect;
    }

    shouldReconnect() {
        return this._reconnect;
    }
}
